<template>
  <div class="text-left">
    <div
      class="time-label"
      :class="{ 'text-danger': timeLost || displayError }"
    >
      {{ label }}
    </div>
    <div class="minutes-label-container mb-2">
      <minutes-label
        :minutes="minutes"
        :class="{
          'lost-calculated-time': timeLost,
          'text-gray': !minutes,
          'text-danger': displayError
        }"
        :default-text="defaultText"
      ></minutes-label>
    </div>
    <div v-if="nextDay" class="next-day-warning">
      <i class="fa-regular fa-calendar-alt mr-1"></i>Next Day
    </div>
  </div>
</template>

<script>
import MinutesLabel from "@/components/MinutesLabel.vue";

export default {
  components: {
    MinutesLabel
  },
  props: {
    minutes: {
      type: Number,
      default: null
    },
    timeLost: {
      type: Boolean,
      default: false
    },
    nextDay: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    noIcon: {
      type: Boolean,
      default: false
    },
    defaultText: {
      type: String,
      default: ""
    },
    scheduledTime: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayError() {
      return this.minutes < 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.lost-calculated-time {
  color: var(--danger-color);
  text-decoration: line-through;
}

.gray-arrow {
  color: var(--secondary-color);
}

.time-label {
  color: var(--text-body, #6f767b);
}
.minutes-label-container {
  display: flex;
  padding: 0.47059rem;
  align-items: center;
  gap: 0.23529rem;
  align-self: stretch;

  border-radius: 0.23529rem;
  background: var(--neutral-gray);
}
</style>
